import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';


import { HisSharedModule } from 'hisng';
import { CommonSharedModule } from 'app/fs/res/common/common-shared.module';
import { PublisherEditFormComponent } from 'app/fs/res/publication/component/publisher/edit/publisher-edit-form.component';
import { PublisherEditBasicDataComponent } from './edit/basic-data/publisher-edit-basic-data.component';
import { PublisherSearchFormComponent } from 'app/fs/res/publication/component/publisher/search/publisher-search-form.component';
import { PublisherViewDetailsComponent } from 'app/fs/res/publication/component/publisher/view/publisher-view-details.component';
import { PublisherSearchResultComponent } from 'app/fs/res/publication/component/publisher/search/publisher-search-result.component';
import { PublisherPlamComponent } from 'app/fs/res/publication/component/publisher/edit/publisher-plam.component';
import { PublisherEditBasicDataTabComponent } from './edit/publisher-edit-basic-data-tab.component';

@NgModule( {
    imports: [
        HisSharedModule,
        CommonSharedModule,
        // primeng
        PanelModule,
        DialogModule,
        TableModule,
        TabViewModule,
        AutoCompleteModule,
        ConfirmDialogModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],

    declarations: [
        PublisherEditFormComponent,
        PublisherEditBasicDataComponent,
        PublisherViewDetailsComponent,
        PublisherSearchFormComponent,
        PublisherSearchResultComponent,
        PublisherPlamComponent,
        PublisherEditBasicDataTabComponent
    ],

    exports: [
        PublisherEditFormComponent,
        PublisherPlamComponent
    ]
} )

export class PublisherSharedModule { }
